import { computed, type ComputedRef } from 'vue';

import type { IPublicOrganizationData } from '@/types/IPublicOrganizationData';

type HelperPicture = {
  picture: string;
  position: string;
  size: string;
  blur?: boolean;
};

export function useHelpeeHelperPictures(params: {
  helpeeSignUpData: ComputedRef<IPublicOrganizationData | null>;
}) {
  const redirectHelpersProfilePicture = computed<HelperPicture[]>(() => {
    const data = params.helpeeSignUpData.value;
    const pictures = data?.helpersProfilePicture;

    const enoughHelpersPics = Boolean(pictures && pictures.length > 4);

    return [
      {
        picture: enoughHelpersPics
          ? (pictures?.[2] ?? '/img/team/hugo.png')
          : '/img/team/hugo.png',
        position: 'top-11 left-[15%]',
        size: 'h-12 w-12',
      },
      {
        picture: enoughHelpersPics
          ? (pictures?.[3] ?? '/img/team/joris.png')
          : '/img/team/joris.png',
        position: 'bottom-4 left-[20%]',
        size: 'h-12 w-12',
      },
      {
        picture: enoughHelpersPics
          ? (pictures?.[0] ?? '/img/team/marine.png')
          : '/img/team/marine.png',
        position: 'bottom-1/4 right-[40%]',
        size: 'h-12 w-12',
      },
      {
        picture: enoughHelpersPics
          ? (pictures?.[4] ?? '/img/team/nada.png')
          : '/img/team/nada.png',
        position: 'top-6 right-[30%]',
        size: 'h-12 w-12',
      },
      {
        picture: enoughHelpersPics
          ? (pictures?.[5] ?? '/img/team/edouard.png')
          : '/img/team/edouard.png',
        position: 'bottom-4 right-[15%]',
        size: 'h-12 w-12',
      },
      {
        blur: true,
        picture: '/img/avatars/blur_1.png',
        position: 'top-1/3 right-[55%]',
        size: 'h-8 w-8',
      },
      {
        blur: true,
        picture: '/img/avatars/blur_2.png',
        position: 'top-[40%] right-7',
        size: 'h-8 w-8',
      },
      {
        blur: true,
        picture: '/img/avatars/blur_3.png',
        position: 'bottom-1/4 left-7',
        size: 'h-8 w-8',
      },
    ];
  });

  return {
    redirectHelpersProfilePicture,
  };
}
